import './Forgot.css';
import React, { useRef, useEffect } from "react";
import { connect } from 'react-redux';
import { withTranslate } from 'react-redux-multilingual';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';

import {
    ValidateEmail,
} from '../../../libraries/Tool';

import {
    ForgotPassword
} from '../../../services/Auth.service';

function Forgot(props) {
    const { translate, SnackbarAlert } = props;
    const typingTimeoutRef = useRef(null);
    const [email, setEmail] = React.useState();
    const [emailInvalid, setEmailInvalid] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const handleOnChangeEmail = (e) => {
        if(typingTimeoutRef.current){
            clearTimeout(typingTimeoutRef.current);
        };
        typingTimeoutRef.current = setTimeout(()=>{
            setEmail(e.target.value);
            setEmailInvalid(!ValidateEmail(e.target.value));
        },500)
    }

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    const handleSendPasswordReset = async () => {
        let event;
        let locale = localStorage.getItem('_locale') || 'en';
        if(!email) setEmailInvalid(true);
        if(email && !emailInvalid) {
            setLoading(true);
            event = ForgotPassword({locale, email});
            setTimeout(() => {
                Array.from(document.querySelectorAll("input,textarea")).forEach(
                input => (input.value = "")
                );
            }, 1000)
        }
        event?.then(res => {
            setLoading(false);
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: res?.data?.status,
                        message: translate(`${res?.data?.msg}`, { email }),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        })
        .catch(err => {{
            setLoading(false);
            setTimeout(() => {
                props.dispatch({ 
                    type: 'UPDATE_SNACKBARALERT', 
                    SnackbarAlert: {
                        open: true,
                        severity: err?.response?.data?.status,
                        message: translate(`${err?.response?.data?.msg}`),
                        handleClose: () => handleCloseSnackbarAlert()
                    } 
                });
            }, 1000)
        }})
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [])

    return (
        <div>
            <Container maxWidth="sm" sx={{ my: 20 }}>
                <Typography variant="h3" gutterBottom component="div" sx={{ textAlign: "left", fontWeight: "bold" }}>
                    {translate('forgotyourpassword')}
                </Typography>
                <Typography variant="h6" gutterBottom component="div" sx={{ color: "#586978", fontWeight: "bold", mb: "3em", textAlign: "left" }}>
                    {translate('forgotyourpassworddescription')}
                </Typography>
                <Box 
                    component="form"
                    sx={{
                        '& > :not(style)': { m: 1, display: "flex", justifyContent: "left" },
                      }}
                    noValidate
                    className="forgot-box-main"
                >
                    <InputLabel htmlFor="email">{translate('emailaddress')}</InputLabel>
                    <TextField 
                        autoFocus
                        type="email"
                        size="small"
                        fullWidth={true} 
                        id="email" 
                        variant="outlined" 
                        sx={{ backgroundColor: "#fff" }}
                        onChange={handleOnChangeEmail}
                        error={
                            emailInvalid
                        }
                        helperText={
                            (emailInvalid) ? translate('pleaseenteravalidemailaddress') :
                            ""
                        }
                    />
                    <Box sx={{ pt: 10 }}>
                        <LoadingButton
                            onClick={handleSendPasswordReset}
                            endIcon={<SendIcon />}
                            loading={loading}
                            loadingPosition="end"
                            variant="contained"
                            >
                            {translate('sendpasswordreset')}
                        </LoadingButton>
                    </Box>
                </Box>
            </Container>
        </div>
    )
}
function mapStateToProps(state) {
    return {
      UserInfor: state.UserInfor,
      SnackbarAlert: state.SnackbarAlert,
    }
}
export default connect(mapStateToProps)(withTranslate(Forgot));